import { getSession } from "@/api/user";
import { FXBO } from "@/config/common";
import { IUser, IUserInfo } from "@/props/IUser";
import { getCookie, setCookie } from "cookies-next";
import { cookieOptions, setUserInfoCookie } from "@/utils/cookie";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useAppDispatch } from "@/store/hooks";
import { setToken, setUserInfo } from "@/store/user";
import { onKeyActivate } from "@/utils/index";

const SwitchAccount = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const user: IUser | any = getCookie("user");
  const token: string | undefined = getCookie("token");
  // 防御：user cookie 可能是脏值（如跨站传参异常时的 "undefined"），JSON.parse 失败不应整页崩溃
  const parseUser = (raw: any) => {
    if (!raw || raw === "undefined" || raw === "null") return {};
    try {
      return JSON.parse(raw);
    } catch {
      return {};
    }
  };
  const { fxboToken = "", bssToken = "" } = parseUser(user);
  const dispatch = useAppDispatch();

  // handleSwitchAccount
  const handleSwitchAccount = async () => {
    const curToken = (token || "").indexOf(FXBO) >= 0 ? bssToken : fxboToken;
    setCookie("token", curToken, cookieOptions());
    dispatch(setToken(curToken));
    const userInfo: IUserInfo | any = await getSession();
    setUserInfoCookie(userInfo);
    dispatch(setUserInfo(userInfo));
    router.replace("/");
  };

  return fxboToken && bssToken ? (
    <div
      className="flex h-10 min-w-108px cursor-pointer items-center font-semibold hover:text-primary transition-colors duration-200"
      onClick={handleSwitchAccount}
      role="button"
      tabIndex={0}
      onKeyDown={onKeyActivate(handleSwitchAccount)}
    >
      {t("common.switch_account")}
    </div>
  ) : null;
};

export default SwitchAccount;
